import React, {ReactElement, ReactNode, useState} from "react";
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import {
    Container,
    TitleContainer,
    Title,
    ArrowIconContainer,
    ContentContainer,
    IconImage,
    PreviewContainer
} from './CollapsableContainer.styles'

interface CollapsableContainerProps {
    title: string,
    defaultIsOpen?: boolean,
    children?: ReactNode
    icon?: string;
    backgroundColor?: string;
    noBorder?: boolean
    preview?: ReactNode
    fullPreview?: boolean
}

const CollapsableContainer: React.FC<CollapsableContainerProps> = ({ title, icon, backgroundColor, noBorder, defaultIsOpen = false, children, preview, fullPreview = false }: CollapsableContainerProps) => {
    const [isOpen, setIsOpen] = useState(defaultIsOpen)

    return (
        <Container $backgroundColor={backgroundColor}>
            <TitleContainer className="no-fastclick" onClick={() => setIsOpen(!isOpen)} $noBorder={noBorder}>
                <Title>{icon &&  <IconImage src={icon} alt="Icon" width={'75%'}/>} {title}</Title>
                <ArrowIconContainer>{isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}</ArrowIconContainer>
            </TitleContainer>
            {isOpen ? <ContentContainer>
                {children}
            </ContentContainer>
                : <>{fullPreview
                    ? <>{preview}...</>
                    : preview ? <><PreviewContainer>{preview}</PreviewContainer>...</> : null
                }</>}
        </Container>
    )
}

export default CollapsableContainer;
